/* global appData */

import $ from 'jquery';
import Vue from 'vue';

const notProduction = process.env.NODE_ENV !== 'production';

// initial state
const state = {
	data: {},
};

// getters
const getters = {

};

// actions
const actions = {
	initializeData({commit}) {
		$.get(`${appData.networkSiteUrl}wp-json/kla/v1/apps-data`)
			.then(content => {
				commit('setupData', content);
			});
	}
};

// mutations
const mutations = {
	setupData(state, value) {
		Vue.set(state, 'data', value);
	},
	updateData(state, payload) {
		if (notProduction) {
			console.log(payload.name, payload.value);
		}
		Vue.set(state.data, payload.name, payload.value);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};


// WEBPACK FOOTER //
// ./assets/_js/store/modules/apps-data.js